import {
  Button,
  Checkbox,
  Col,
  Image,
  Input,
  Layout,
  Modal,
  Radio,
  Row,
  message,
} from 'antd';
import { reverse } from 'named-urls';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { usecandidateTestStore } from '../../../store/candidateReducer';
import { usecandidateSidebarStore } from '../../../store/candidateSidevarReducer';
import routes from '../../../controller/Routes';
import { useVideoStreamStore } from '../../../store/CamareStreamResucer';

const Question = ({ submit,buttonLoading }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [answer, setAnswer] = useState([]);
  const [totalAnswer, setTotalAnswer] = useState(0);
  const [totalQuestion, setTotalQuestion] = useState(0);
  const [modal, setmodal] = useState(false)
  const [nextbtnvisible,setNextbtnVisible]=useState(true)
  const { menuItem, menuItemValue, updatemenuItemValue, updateMenuItem } =
    usecandidateSidebarStore((state) => state);
  const { stream } = useVideoStreamStore()
  const {
    currentsectionIndex,
    currentquestionindex,
    testquestions,
    updatetestquestions,
    updatecurrentsectionIndex,
    updatecurrentquestionindex,
  } = usecandidateTestStore((state) => state);


  const handleNext = () => {
    if (answer?.length) {
      let test = [...testquestions];
      test[currentsectionIndex].questions[currentquestionindex] = {
        ...test[currentsectionIndex].questions[currentquestionindex],
        candidateAnswer: answer,
      };
      updatetestquestions(test);

      if (
        test[currentsectionIndex]?.questions[currentquestionindex + 1] ==
        undefined
      ) {
        if (test[currentsectionIndex + 1]?.questions[0] == undefined) {
         setNextbtnVisible(false)
        } else {
          updatecurrentquestionindex(0);
          updatecurrentsectionIndex(currentsectionIndex + 1);
          updatemenuItemValue(menuItemValue + 1);
          if (test[currentsectionIndex + 1]?.questions[0]?.candidateAnswer?.length) {
            setAnswer(test[currentsectionIndex + 1]?.questions[0]?.candidateAnswer)
          } else {
            setAnswer([]);
          }
        }
      } else {
        updatecurrentquestionindex(currentquestionindex + 1);
        if (test[currentsectionIndex]?.questions[currentquestionindex + 1]?.candidateAnswer?.length) {
          setAnswer(test[currentsectionIndex]?.questions[currentquestionindex + 1]?.candidateAnswer)
        } else {
          setAnswer([]);
        }

      }

      let itemdata = [...menuItem];
      if (!test[currentsectionIndex].questions[currentquestionindex].isAnswered) {
        itemdata[currentsectionIndex].complete =
          ((currentquestionindex + 1) /
            test[currentsectionIndex].questions.length) *
          100;
        itemdata[currentsectionIndex].totalanswer += 1;
        test[currentsectionIndex].questions[currentquestionindex].isAnswered = true;
        updateMenuItem(itemdata);
      }
    } else {
      message.info('Select the answer');
    }
  };

  // const handleNext = () => {
  //   if (answer?.length) {
  //     let test = [...testquestions];
  //     test[currentsectionIndex].questions[currentquestionindex] = {
  //       ...test[currentsectionIndex].questions[currentquestionindex],
  //       candidateAnswer: answer,
  //     };
  //     updatetestquestions(test);
  //     let itemdata = [...menuItem];
  //     itemdata[currentsectionIndex].complete =
  //       ((currentquestionindex + 1) /
  //         test[currentsectionIndex].questions.length) *
  //       100;
  //     itemdata[currentsectionIndex].totalanswer =
  //       itemdata[currentsectionIndex].totalanswer + 1;
  //     updateMenuItem(itemdata);
  //     if (
  //       test[currentsectionIndex]?.questions[currentquestionindex + 1] ==
  //       undefined
  //     ) {
  //       if (test[currentsectionIndex + 1]?.questions[0] == undefined) {
  //         setmodal(true)
  //       } else {
  //         let itemdata = [...menuItem];
  //         itemdata[currentsectionIndex].complete =
  //           ((currentquestionindex + 1) /
  //             test[currentsectionIndex].questions.length) *
  //           100;
  //         itemdata[currentsectionIndex].totalanswer =
  //           itemdata[currentsectionIndex].totalanswer + 1;
  //         updateMenuItem(itemdata);
  //         updatecurrentquestionindex(0);
  //         updatecurrentsectionIndex(currentsectionIndex + 1);
  //         updatemenuItemValue(menuItemValue + 1);
  //         setAnswer([]);
  //       }
  //     } else {
  //       updatecurrentquestionindex(currentquestionindex + 1);
  //       setAnswer([]);
  //     }
  //   } else {
  //     message.info('Select the answer');
  //   }
  // };

  const getTotalQuestion = () => {
    let totalquestion = menuItem?.reduce((acc, item) => {
      return (acc += item?.totalquestion);
    }, 0);
    console.log(totalquestion, 'menuItem', menuItem);
    return totalquestion;
  };
  const getTotalAnswer = () => {
    let totalquestion = menuItem?.reduce((acc, item) => {
      return (acc += item?.totalanswer);
    }, 0);
    console.log(totalquestion, 'menuItemans', menuItem);
    return totalquestion;
  };
  useEffect(() => {
    setTotalQuestion(getTotalQuestion());
    setTotalAnswer(getTotalAnswer());
  }, [menuItem]);
  const handlePrev = () => {
    let test = [...testquestions];

    if (test[currentsectionIndex]?.questions[currentquestionindex - 1] == undefined) {
      if (test[currentsectionIndex - 1]?.questions != undefined) {
        const prevSectionIndex = currentsectionIndex - 1;
        const lastQuestionIndex = test[prevSectionIndex].questions.length - 1;

        updatecurrentquestionindex(lastQuestionIndex);
        updatecurrentsectionIndex(prevSectionIndex);
        updatemenuItemValue(menuItemValue - 1);

        // Set answer for the last question of the previous section
        const candidateAnswer =
          test[prevSectionIndex]?.questions[lastQuestionIndex]?.candidateAnswer;
        setAnswer(candidateAnswer?.length ? candidateAnswer : []);
      }
    } else {
      // Move to the previous question in the same section
      updatecurrentquestionindex(currentquestionindex - 1);

      const candidateAnswer =
        test[currentsectionIndex]?.questions[currentquestionindex - 1]?.candidateAnswer;
      setAnswer(candidateAnswer?.length ? candidateAnswer : []);
    }
  };


  const isLastQuestion =
  currentsectionIndex === testquestions?.length - 1 &&
  currentquestionindex ===
    testquestions[testquestions.length - 1]?.questions?.length - 1;
  return (
    <>
      <Row className='pt-lg-5 container-lg p-lg-4 p-sm-2 p-md-3 custom-question-page-container  ' style={{ height: "90%", overflowY: 'auto', background: "white" }}>
        <Col lg={15} sm={24} md={20} className=''>
          <div className='fw-semibold fs-6 text-color-custom'>
            Question {currentquestionindex + 1}
          </div>
          <div className='fw-bold fs-4 mb-3'>
            {
              testquestions[currentsectionIndex]?.questions[
                currentquestionindex
              ]?.title
            }
          </div>
          <div>
            {testquestions[currentsectionIndex]?.questions[currentquestionindex]
              ?.imageUrl !== '' && (
                <Image
                  src={
                    testquestions[currentsectionIndex]?.questions[
                      currentquestionindex
                    ]?.imageUrl
                  }
                  className='rounded-3 image-customization mt-2 mb-2'
                  height={180}
                  width={180}
                />
              )}
          </div>
          <Row gutter={[15, 16]} className='mt-4'>
            {testquestions[currentsectionIndex]?.questions[currentquestionindex]
              ?.questionType == 'single_choice' ? (
              <Radio.Group
                className='w-100 d-flex  flex-column gap-3 option-list'
                onChange={(val) => setAnswer([val.target.value])}
                value={answer[0]}
              >
                {testquestions[currentsectionIndex]?.questions[
                  currentquestionindex
                ]?.options?.map((val, index) => {
                  return (
                    <>
                      <Radio
                        value={index}
                        className={`w-100 border  option-item rounded-2 ${answer[0] == index && 'background-color-custom'
                          }`}
                      >
                        <Col className=' fw-bold text-muted w-100' span={24}>
                          {val?.text}
                        </Col>
                      </Radio>
                      {val?.image_url !== '' && (
                        <Image
                          src={val?.image_url}
                          className='rounded-3 image-customization mt-2 mb-4'
                          height={180}
                          width={180}
                        />
                      )}
                    </>
                  );
                })}
              </Radio.Group>
            ) : (
              <Checkbox.Group
                className='w-100 d-flex  flex-column gap-3 option-list'
                onChange={(val) => setAnswer(val)}
                value={answer}
              >
                {testquestions[currentsectionIndex]?.questions[
                  currentquestionindex
                ]?.options?.map((val, index) => {
                  return (
                    <>
                      <Checkbox
                        value={index}
                        className={`w-100 border  option-item rounded-2 ${answer.includes(index) && 'background-color-custom'
                          }`}
                      >
                        <Col
                          className=' p-2 fw-bold text-muted w-100'
                          span={24}
                        >
                          {val?.text}
                        </Col>
                      </Checkbox>
                      {val?.image_url !== '' && (
                        <Image
                          src={val?.image_url}
                          className='rounded-3 image-customization'
                          height={180}
                          width={180}
                        />
                      )}
                    </>
                  );
                })}
              </Checkbox.Group>
            )}
          </Row>
        </Col>
        {/* <Col lg={9} sm={0} md={4} className='d-flex justify-content-end align-items-end'>
          {stream && <video
            autoPlay
            playsInline
            style={{ width: '70%' }}
            muted
            ref={(video) => {
              if (video) video.srcObject = stream;
            }}
          />}
        </Col> */}
      </Row>
      <div className='border-top w-100 d-flex align-items-center justify-content-between p-2' style={{ height: '10%' }}>
        <div className='d-flex gap-5'>
          <Button
            type='text'
            className='w-auto h-auto text-color-custom fw-bold fs-5 p-2 d-flex justify-content-center align-items-center next-btn'
            onClick={() => {
              setNextbtnVisible(true)
              handlePrev()
            }}
            disabled={currentsectionIndex == 0 && currentquestionindex == 0 ? true : false}
          >
            <LeftOutlined />
            Previous
          </Button>
          <Button
            type='text'
            className='w-auto h-auto text-color-custom p-2 d-flex justify-content-center align-items-center next-btn'
            onClick={() => handleNext()}
            disabled={nextbtnvisible?false:true}
          >
            Next
            <RightOutlined />
          </Button>
        </div>
        {/* {totalQuestion - totalAnswer == 1 || totalQuestion - totalAnswer == 0 ? (
          <Button
            type='primary'
            className='w-auto h-auto button-color p-2 d-flex justify-content-center align-items-center submit-btn'
            onClick={() => {
              if (answer?.length) {
                handleNext()
                // submit(routes?.test?.thankyou)
              } else {
                message.info('Select the answer');
              }
            }}
          >
            Submit <RightOutlined />
          </Button>
        ) : (
          <Button
            type='text'
            className='w-auto h-auto text-color-custom p-2 d-flex justify-content-center align-items-center next-btn'
            onClick={() => handleNext()}
            disabled={totalQuestion - totalAnswer == 1 ? true : false}
          >
            Next
            <RightOutlined />
          </Button>
        )} */}
        <Button
          type='primary'
          className='w-auto h-auto button-color p-2 d-flex justify-content-center align-items-center submit-btn'
          onClick={() => {
            if (answer?.length) {
              let test = [...testquestions];
              test[currentsectionIndex].questions[currentquestionindex] = {
                ...test[currentsectionIndex].questions[currentquestionindex],
                candidateAnswer: answer,
              };
              updatetestquestions(test);
              setmodal(true);

            } else {
              setmodal(true);
            }
          }}
        >
          Submit Test
        </Button>
      </div>
      {/* <Layout  style={{height:"87vh"}} className='' >
      <Layout.Content>
      
      </Layout.Content>
      <Layout.Footer style={{widows:"100%",padding:"10px !important",background:"white",borderTop:"1px solid"}}>
      <Row className=''>
        <Col xl={24} lg={24} sm={24} md={24} className='w-100'>
          <Row className='w-100' justify={'end'}>
            <Col lg={4} md={6} sm={6}>
              <Button
                type='text'
                className='w-100 h-auto text-color-custom fw-bold fs-5 p-1 d-flex justify-content-center align-items-center'
                onClick={() => handlePrev()}
              >
                <LeftOutlined />
                Pervious
              </Button>
            </Col>
            <Col lg={4} md={6} sm={6}>
              {totalQuestion - totalAnswer == 1||totalQuestion - totalAnswer == 0 ? (
                <Button
                  type='primary'
                  className='w-100 h-auto button-color p-1 d-flex justify-content-center align-items-center submit-btn'
                  onClick={() => {
                    if (answer?.length) {
                      handleNext()
                      // submit(routes?.test?.thankyou)
                    } else {
                      message.info('Select the answer');
                    }
                  }}
                >
                  Submit <RightOutlined />
                </Button>
              ) : (
                <Button
                  type='text'
                  className='w-100 h-auto text-color-custom p-1 d-flex justify-content-center align-items-center next-btn'
                  onClick={() => handleNext()}
                  disabled={totalQuestion - totalAnswer == 1 ? true : false}
                >
                  Next
                  <RightOutlined />
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      </Layout.Footer>
     </Layout> */}
      {/* {totalQuestion - totalAnswer != 1 && (
        <Row className='mt-5 mb-0'>
          <Col xl={24} lg={24} sm={24} md={24} className='w-100 mt-5'>
            <Row className='w-100' justify={'end'}>
             
              <Col lg={4} md={6} sm={6}>
                <Button
                  type='primary'
                  className='w-100 h-auto button-color p-1 d-flex justify-content-center align-items-center submit-btn'
                  onClick={() => {
                    setmodal(true)
                  }}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      )} */}
      <Modal
        width={350}
        className='submit-popup'
        title=''
        open={modal}
        footer={null}
        closeIcon={null}
            maskClosable={false} 
      >
        <div className='w-100  text-center d-flex flex-column gap-3'>
          <span className=' fs-5 fw-bold '>Are You Sure You Want To Submit The Test? </span>
          <p className='paragraph'>
          You won't be able to get back to the test once you submit.
          </p>
          <Row justify={'center'} gutter={[12, 12]}>
            <Col span={8}>
              <Button
                // type='primary'
                // className='w-100 h-auto button-color p-1 d-flex justify-content-center align-items-center submit-btn'
                type='default'
                className=' w-100 text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn submit-btn'
                onClick={() => setmodal(false)}
                disabled={buttonLoading}
              >
                Cancel
              </Button>
            </Col>
            <Col span={8}>
              <Button
                type='primary'
                className=' w-100 button-color fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn submit-btn'
                loading={buttonLoading}
                onClick={async() => {
                 await submit(routes?.test?.thankyou,setmodal)
                  setmodal(false)
                }}
              >
                Yes
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default Question;
